"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDisplayValue = exports.SourcePathAdapter = void 0;
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var model_js_1 = require("@cognitoforms/model.js"); // eslint-disable-line import/no-duplicates
var model_js_2 = require("@cognitoforms/model.js"); // eslint-disable-line import/no-duplicates
var source_adapter_1 = require("./source-adapter");
var source_option_adapter_1 = require("./source-option-adapter");
var model_js_3 = require("@cognitoforms/model.js"); // eslint-disable-line import/no-duplicates
var vue_model_observability_1 = require("./vue-model-observability");
var model_js_4 = require("@cognitoforms/model.js"); // eslint-disable-line import/no-duplicates
var model_js_5 = require("@cognitoforms/model.js"); // eslint-disable-line import/no-duplicates
var source_item_adapter_1 = require("./source-item-adapter");
var model_js_6 = require("@cognitoforms/model.js"); // eslint-disable-line import/no-duplicates
var model_js_7 = require("@cognitoforms/model.js"); // eslint-disable-line import/no-duplicates
var helpers_1 = require("./helpers");
var _id = 0;
// @ts-ignore
var SourcePathAdapter = /** @class */ (function (_super) {
    __extends(SourcePathAdapter, _super);
    function SourcePathAdapter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // viewState: { formatError: ConditionTarget } = { formatError: null };
        // formatError: FormatError = null;
        _this.formatErrorCondition = null;
        _this.id = "".concat(_id++);
        return _this;
    }
    Object.defineProperty(SourcePathAdapter.prototype, "parent", {
        get: function () {
            for (var parentVm = this.$parent.$parent, parentLevel = 1; parentVm != null; parentVm = parentVm.$parent, parentLevel += 1) {
                if ((0, source_adapter_1.isSourceAdapter)(parentVm.$source)) {
                    return parentVm.$source;
                }
            }
            throw new Error("Parent source not found!");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourcePathAdapter.prototype, "property", {
        get: function () {
            var property = this.parent.type.meta.getPath(this.source);
            (0, vue_model_observability_1.preventVueObservability)(property);
            return property;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourcePathAdapter.prototype, "type", {
        get: function () {
            // If possible, determine the type based on the actual entity instance
            if (this.value && (0, helpers_1.isEntity)(this.value))
                return this.value.meta.type.jstype;
            return this.property.propertyType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourcePathAdapter.prototype, "isList", {
        get: function () {
            return this.property.isList;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourcePathAdapter.prototype, "lastTarget", {
        get: function () {
            var property = this.property;
            return property.getLastTarget(this.parent.value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourcePathAdapter.prototype, "label", {
        /**
         *  Gets the label for the source property.
         *
         *  @returns The source override label if specified, or the model property label if not
         */
        get: function () {
            var label = this.overrides ? this.overrides.label : null;
            if (label === undefined || label === null) {
                if (this.property.labelIsFormat) {
                    label = (0, model_js_2.evaluateLabel)(this.property, this.parent.value);
                }
                else {
                    label = this.property.label;
                }
            }
            return label;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourcePathAdapter.prototype, "helptext", {
        /**
         *  Gets the helptext for the source property.
         *
         *  @returns The source override helptext if specified, or the model property helptext if not
         */
        get: function () {
            var helptext = this.overrides ? this.overrides.helptext : null;
            if (helptext === undefined || helptext === null) {
                if (this.property.helptextIsFormat) {
                    helptext = this.parent.value.toString(this.property.helptext);
                }
                else {
                    helptext = this.property.helptext;
                }
            }
            return helptext;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourcePathAdapter.prototype, "readonly", {
        /**
         *  Indicants whether the source property is readonly.
         *
         *  @returns True if either the parent source or the source override is read only, otherwise false
         */
        get: function () {
            return this.parent.readonly || (this.overrides ? !!this.overrides.readonly : false);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourcePathAdapter.prototype, "required", {
        /**
        *  Indicants whether the source property is required.
        *
        *  @returns True if the property is required, otherwise false
        */
        get: function () {
            if (this.overrides && this.overrides.required != null)
                return this.overrides.required;
            if ((0, model_js_2.isPropertyBooleanFunctionAndOptions)(this.property.required)) {
                if ((0, model_js_2.isPropertyBooleanFunction)(this.property.required.function)) {
                    return this.property.required.function.call(this.parent.value);
                }
                else {
                    return true;
                }
            }
            if ((0, model_js_2.isPropertyBooleanFunction)(this.property.required))
                return this.property.required.call(this.parent.value);
            return this.property.required === true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourcePathAdapter.prototype, "value", {
        /**
         *  Gets the value of the source property on the entity.
         *
         *  @returns The observable raw value of the property
         */
        get: function () {
            // This adapter has no value if its parent has no value
            if (!this.parent.value)
                return;
            return this.ensureObservable(this.property.value(this.parent.value));
        },
        /**
         *  Sets the value of the source property on the entity.
         *
         *  @param value - The new value to assign to the property
         */
        set: function (value) {
            if (this.property.isList) {
                var valueArray_1 = value;
                var observableArray_1 = this.property.value(this.parent.value);
                observableArray_1.batchUpdate(function () { return (0, model_js_5.updateArray)(observableArray_1, valueArray_1); });
            }
            else {
                this.property.value(this.parent.value, this.ensureObservable(value));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourcePathAdapter.prototype, "conditions", {
        get: function () {
            var _this = this;
            var meta = this.parent.value.meta;
            var metaOb = (0, vue_model_observability_1.getObjectMetaObserver)(meta);
            // Make sure that the meta object is observable, ex: subscribes to conditions array changed
            metaOb.ensureObservable();
            var conditionTargets = meta.conditions;
            conditionTargets.forEach(function (condition) { (0, vue_model_observability_1.preventVueObservability)(condition); });
            // Raise property access to let Vue know that array was accessed
            // Changes to conditions will result in a Vue change notification for the 'conditions' property
            metaOb.onPropertyAccess("conditions", conditionTargets);
            var formatErrorConditions = this.formatErrorCondition ? [this.formatErrorCondition] : [];
            var property = this.property instanceof model_js_2.Property ? this.property : this.property instanceof model_js_4.PropertyChain ? this.property.lastProperty : null;
            if (!property)
                return formatErrorConditions;
            var conditions = conditionTargets.filter(function (c) { return c.properties.indexOf(property) >= 0; }).map(function (conditionTarget) {
                return conditionTarget.condition;
            });
            conditions = conditions.concat(formatErrorConditions);
            conditions = conditions.sort(function (conditionA, conditionB) {
                return _this.compare(conditionA, conditionB);
            });
            return conditions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourcePathAdapter.prototype, "formatError", {
        get: function () {
            return this.formatErrorCondition ? this.formatErrorCondition["formatError"] : null;
        },
        set: function (err) {
            if (err) {
                (0, vue_model_observability_1.preventVueObservability)(err);
                var formatErrorCondition = err.createCondition(this.property.getLastTarget(this.parent.value), this.property.lastProperty);
                (0, vue_model_observability_1.preventVueObservability)(formatErrorCondition);
                formatErrorCondition["formatError"] = err;
                this.formatErrorCondition = formatErrorCondition;
            }
            else {
                this.formatErrorCondition = null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourcePathAdapter.prototype, "invalidValue", {
        get: function () {
            if (this.formatError) {
                return this.formatError.invalidValue;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourcePathAdapter.prototype, "firstError", {
        get: function () {
            return this.conditions.length ? this.conditions[0] : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourcePathAdapter.prototype, "displayValue", {
        get: function () {
            if (this.formatError) {
                return this.formatError.invalidValue;
            }
            var value = this.ensureObservable(this.property.value(this.parent.value));
            return formatDisplayValue(this, value);
        },
        set: function (text) {
            if ((0, model_js_6.isEntityType)(this.property.propertyType)) {
                throw new Error("Cannot set displayValue property of Adapters for entity types.");
            }
            /// / TODO: Implement auto-reformat?
            // var initialValue = text;
            var newValue;
            var formatter;
            if (this.property.format != null) {
                formatter = this.property.format;
            }
            else if ((0, model_js_6.isValueType)(this.property.propertyType) && this.property.propertyType !== String) {
                // Try to use the general format by default
                formatter = this.property.containingType.model.getFormat(this.property.propertyType, "G");
            }
            if (this.formatError) {
                this.parent.value.meta.clearCondition(model_js_7.FormatError.ConditionType); // TODO: This shouldn't do anything...
                this.formatError = null;
            }
            if (formatter) {
                newValue = formatter.convertBack(text);
                if (newValue instanceof model_js_7.FormatError) {
                    (0, vue_model_observability_1.preventVueObservability)(newValue);
                    this.formatError = newValue;
                    return;
                }
            }
            else if (this.property.propertyType === String && typeof text === "string" && text.length === 0) {
                // Convert blank string to null
                newValue = null;
            }
            else {
                newValue = text;
            }
            this.value = newValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourcePathAdapter.prototype, "allowedValuesRule", {
        get: function () {
            var property;
            if (this.property instanceof model_js_4.PropertyChain) {
                property = this.property.lastProperty;
            }
            else if (this.property instanceof model_js_2.Property) {
                property = this.property;
            }
            var allowedValuesRules = property.rules.filter(function (r) { return r instanceof model_js_3.AllowedValuesRule; });
            if (allowedValuesRules.length) {
                var allowedValuesRule = allowedValuesRules[0];
                (0, vue_model_observability_1.preventVueObservability)(allowedValuesRule);
                return allowedValuesRule;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourcePathAdapter.prototype, "allowedValues", {
        get: function () {
            var allowedValuesRule = this.allowedValuesRule;
            if (!allowedValuesRule) {
                // If there is no rule, return an empty list
                return;
            }
            var targetObj;
            if (this.property instanceof model_js_4.PropertyChain) {
                targetObj = this.property.getLastTarget(this.parent.value);
            }
            else {
                targetObj = this.parent.value;
            }
            // Retrieve the value of allowed values property
            var allowedValuesFromRule = allowedValuesRule.values(targetObj);
            if (allowedValuesFromRule) {
                // Clear our values that are no longer valid
                if (!allowedValuesRule.ignoreValidation) {
                    this.clearInvalidOptions(allowedValuesFromRule);
                }
            }
            else if (!allowedValuesRule.ignoreValidation) {
                // Clear out values since the property doesn't currently have any allowed values
                this.clearInvalidOptions(null);
            }
            allowedValuesFromRule.forEach(function (value) {
                if (value instanceof model_js_1.Entity) {
                    (0, vue_model_observability_1.observeEntity)(value).ensureObservable();
                }
                else if (typeof value === "object") {
                    (0, vue_model_observability_1.preventVueObservability)(value);
                }
            });
            return allowedValuesFromRule;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourcePathAdapter.prototype, "options", {
        get: function () {
            var _this = this;
            // Destroy existing option components
            var optionsToDestroy = this.$children.filter(function (c) { return c instanceof source_option_adapter_1.SourceOptionAdapter; });
            optionsToDestroy.forEach(function (c) { return c.$destroy(); });
            // TODO: preserve option adapters if possible?
            var allowedValues = this.allowedValues;
            if (!allowedValues && this.property.propertyType === Boolean) {
                // Provide true and false as special allowed values for booleans
                allowedValues = [true, false];
            }
            if (!allowedValues) {
                return [];
            }
            // Map the allowed values to option adapters
            return allowedValues.map(function (v) { return new source_option_adapter_1.SourceOptionAdapter({ parent: _this, propsData: { value: v } }); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourcePathAdapter.prototype, "items", {
        get: function () {
            var items = [];
            // Collect existing option components to potentially be destroyed
            var existingItemsToDestroy = this.$children.filter(function (c) { return c instanceof source_item_adapter_1.SourceItemAdapter; });
            var value = this.value;
            if (Array.isArray(value)) {
                if ((0, model_js_6.isEntityType)(this.property.propertyType)) {
                    var existingItemsMap_1 = {};
                    existingItemsToDestroy.forEach(function (c) {
                        var adapter = c;
                        if (!adapter.isOrphaned) {
                            var key = adapter.value ? adapter.value.meta.id : null;
                            if (key) {
                                existingItemsMap_1[key] = adapter;
                            }
                        }
                    });
                    for (var i = 0; i < value.length; i++) {
                        var key = value[i].meta.id;
                        var existingItem = existingItemsMap_1[key];
                        if (existingItem) {
                            // Delete the existing item from the map so that it can't be fetched more than once
                            delete existingItemsMap_1[key];
                            // Remove the component from the list of items to destroy since we're going to reuse it
                            var existingItemIndex = existingItemsToDestroy.indexOf(existingItem);
                            if (existingItemIndex >= 0) {
                                existingItemsToDestroy.splice(existingItemIndex, 1);
                            }
                            // Set the backing storage for the 'index' prop, the internal data should
                            // already have this value, this just makes the component's state consistent,
                            // since the inconsistency is just a side-effect of reusing item adapters
                            var propsData = existingItem.$options.propsData;
                            propsData.index = i;
                            // Include the existing item in the return value
                            items.push(existingItem);
                        }
                        else {
                            // Create a new item adapter
                            var newItem = new source_item_adapter_1.SourceItemAdapter({ parent: this, propsData: { index: i, parentSource: this } });
                            // Subscribes to changes to its underlying list source in order to update its index and detect when it becomes orphaned
                            newItem.subscribeToSourceChanges();
                            // Include the new item in the return value
                            items.push(newItem);
                        }
                    }
                }
            }
            existingItemsToDestroy.forEach(function (c) { return c.$destroy(); });
            return items;
        },
        enumerable: false,
        configurable: true
    });
    SourcePathAdapter.prototype.compare = function (conditionTargetA, conditionTargetB) {
        if (conditionTargetA["formatError"] instanceof model_js_7.FormatError || conditionTargetB["formatError"] instanceof model_js_7.FormatError) {
            return conditionTargetA["formatError"] instanceof model_js_7.FormatError && conditionTargetB["formatError"] instanceof model_js_7.FormatError ? 0 :
                conditionTargetA["formatError"] instanceof model_js_7.FormatError ? -1 : 1;
        }
        else if (conditionTargetA["source"] instanceof model_js_1.RequiredRule || conditionTargetB["source"] instanceof model_js_1.RequiredRule)
            return conditionTargetA["source"] instanceof model_js_1.RequiredRule && conditionTargetB["source"] instanceof model_js_1.RequiredRule ? 0 :
                conditionTargetA["source"] instanceof model_js_1.RequiredRule ? -1 : 1;
        else if (conditionTargetA.type.category === "Error" || conditionTargetB.type.category === "Error")
            return conditionTargetA.type.category === "Error" && conditionTargetB.type.category === "Error" ? 0 :
                conditionTargetA.type.category === "Error" ? -1 : 1;
        else
            return 0;
    };
    SourcePathAdapter.prototype.clearInvalidOptions = function (allowedValues) {
        var property = this.property;
        var value = this.value;
        if (allowedValues) {
            // Remove option values that are no longer valid
            if (value instanceof Array) {
                var array = value;
                array.batchUpdate(function (array) {
                    // From the `purge()` function in ExoWeb...
                    for (var i = 0; i < array.length; i++) {
                        var item = array[i];
                        if (allowedValues.indexOf(item) < 0) {
                            array.splice(i--, 1);
                        }
                    }
                });
            }
            else if (value !== null && allowedValues.indexOf(value) < 0) {
                property.value(this.parent.value, null);
            }
        }
        else if (value instanceof Array) {
            value.splice(0, value.length);
        }
        else if (value !== null) {
            property.value(this.parent.value, null);
        }
    };
    SourcePathAdapter.prototype.ensureObservable = function (value) {
        if (Array.isArray(value)) {
            if (model_js_5.ObservableArray.isObservableArray(value)) {
                (0, vue_model_observability_1.observeArray)(value).ensureObservable();
            }
            for (var i = 0; i < value.length; i++) {
                var item = value[i];
                if (item instanceof model_js_1.Entity) {
                    (0, vue_model_observability_1.observeEntity)(item).ensureObservable();
                }
            }
        }
        else if (value instanceof model_js_1.Entity) {
            (0, vue_model_observability_1.observeEntity)(value).ensureObservable();
        }
        return value;
    };
    SourcePathAdapter.prototype.toString = function () {
        return "Source['" + this.source + "']";
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)(String),
        __metadata("design:type", String)
    ], SourcePathAdapter.prototype, "source", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)(Object),
        __metadata("design:type", Object)
    ], SourcePathAdapter.prototype, "overrides", void 0);
    SourcePathAdapter = __decorate([
        vue_property_decorator_1.Component
    ], SourcePathAdapter);
    return SourcePathAdapter;
}(vue_1.default));
exports.SourcePathAdapter = SourcePathAdapter;
function formatDisplayValue(adapter, value) {
    var displayValue;
    var property = adapter.property;
    if (value === null || value === undefined) {
        displayValue = "";
    }
    else if (property.format != null) {
        // Use a markup or property format if available
        if (Array.isArray(value)) {
            var array = value;
            displayValue = array.map(function (item) { return property.format.convert(item); });
        }
        else {
            displayValue = property.format.convert(value);
        }
    }
    else if (Array.isArray(value)) {
        // If no format exists, then fall back to toString
        var array = value;
        displayValue = array.map(function (item) {
            if (value === null || value === undefined) {
                return "";
            }
            else {
                return item.toString();
            }
        });
    }
    else {
        displayValue = value.toString();
    }
    displayValue = Array.isArray(displayValue) ? displayValue.join(", ") : displayValue;
    return displayValue;
}
exports.formatDisplayValue = formatDisplayValue;
